"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMiddleware = void 0;
var state_1 = require("./state");
var addMiddleware = function (middleware) {
    var state = (0, state_1.getState)();
    if (!middleware.name || !middleware.handler) {
        throw "Cannot add a middleware: invalid arguments.";
    }
    // if(state.eventQueue.length) {
    //     throw "Cannot add a middleware after an event has been emitted."
    // }
    state.middlewares = __spreadArray(__spreadArray([], state.middlewares.filter(function (_) { return _.name !== middleware.name; }), true), [middleware], false);
};
exports.addMiddleware = addMiddleware;
